/* @flow */

import { Store } from 'redux';
import isFunction from 'lodash/isFunction';
import 'autotrack/lib/plugins/event-tracker';
import 'autotrack/lib/plugins/outbound-link-tracker';
import 'autotrack/lib/plugins/url-change-tracker';
import 'autotrack/lib/plugins/media-query-tracker';
import 'autotrack/lib/plugins/page-visibility-tracker';
import config from '../config';

function start(store: Store): void {
  var analytics = {
    trackers: []
  };

  if (config.GOOGLE_ANALYTICS) {
    for (var trackerName in config.GOOGLE_ANALYTICS) {
      analytics.trackers.push(trackerName);

      ga('create', config.GOOGLE_ANALYTICS[trackerName], 'auto', trackerName);

      // Only require the plugins you've imported above.
      ga(trackerName+'.require', 'eventTracker');
      ga(trackerName+'.require', 'outboundLinkTracker');
      ga(trackerName+'.require', 'urlChangeTracker');
      ga(trackerName+'.require', 'mediaQueryTracker');
      ga(trackerName+'.require', 'pageVisibilityTracker');

      ga(trackerName+'.send', 'pageview');

    }
  }

  analytics.track = function(event, properties, options, callback) {
    if (isFunction(callback)) {
      callback();
    }
  }

  window.analytics = analytics;
};

export { start };
